// extracted by mini-css-extract-plugin
module.exports = {"container":"StrategyActions_container__1hFZb"};